import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import LanguageSelect from './LanguageSelect';
import ResturantInfoPanel from './ResturantInfoPanel';
import MainMenuCards from './MainMenuCards';
import SearchPanel from './SearchPanel';
import AWS from 'aws-sdk';
import { v4 as uuidv4 } from 'uuid';
import AddCartButton from './AddCartButton';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import OfferIcon from '../../images/HomeImages/DiscountImage.png';
import '../../fonts/font.css'
import LocationIcon from '../MenuImages/Marker.png';
import PhoneIcon from '../MenuImages/Phone.png';
import ForwardIcon from '../../images/NavBarImages/Forward_100px.png';


const EMenu = () => {

  const navigate = useNavigate();
  const param = useParams();
  const [DBGroups, setDBGroups] = useState([]);
  const [DBItems, setDBItems] = useState([]);
  const [Groups, setGroups] = useState([]);
  const [Items, setItems] = useState([]);
  const [ItemDetails, setItemDetails] = useState([]);
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [LanguageID, setLanguageID] = useState(1);
  const [RestInformation, setRestInformation] = useState([]);
  const [DBDepartment, setDBDepartment] = useState([]);
  const [SelectedDepartment, setSelectedDepartment] = useState('aa');
  const [SelectedType, setSelectedType] = useState('Group');
  const [SelectedGroup, setSelectedGroup] = useState('');
  const [SelectedGroupName, setSelectedGroupName] = useState('');
  const [SelectdetItem, setSelectdetItem] = useState('');
  const [SearchedItem, setSearchedItem] = useState('');
  const [BackStatus, setBackStatus] = useState('Item');
  const [BranchimageUrl, setBranchimageUrl] = useState(null);
  const [SubsecriptionType, setSubsecriptionType] = useState('');
  const [ItemCount, setItemCount] = useState(1);
  const [cart, setCart] = useState([]);
  const [Product, setProduct] = useState([]);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [CostAddress, setCostAddress] = useState('');
  const [CostPhone, setCostPhone] = useState('');
  const [Note, setNote] = useState('');
  const [DBItemSize, setDBItemSize] = useState([]);
  const [ItemSize, setItemSize] = useState([]);
  const [SelectedItemSize, setSelectedItemSize] = useState([]);

  const [ItemNote, setItemNote] = useState('');
  const [BranchDiscount, setBranchDiscount] = useState(0);
  const [DBBranchDiscount, setDBBranchDiscount] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [DeliveryTransPrice, setDeliveryTransPrice] = useState(0);
  const [DBDeliveryTransPrice, setDBDeliveryTransPrice] = useState(0);
  const [OrederMinimunAmount, setOrederMinimunAmount] = useState(0);
  const [AddCartButtonStatus, setAddCartButtonStatus] = useState('PhoneInfo');
  const [Otp, setOtp] = useState(new Array(3).fill(""));
  const CartTotalPrcice = cart.reduce((total, item) => total + (item.totalPrice || 0), 0);

  const baseDiscount = CartTotalPrcice * BranchDiscount / 100;
  const adjustedDiscount = baseDiscount === 0 ? 0 : Math.ceil(baseDiscount / 250) * 250;
  const [LeastDiscount, setLeastDiscount] = useState(0);
  //const CartTotalDiscount = adjustedDiscount === 0 ? 0 : Math.max(adjustedDiscount, 250);
  const CartTotalDiscount =
    adjustedDiscount === 0
      ? 0
      : LeastDiscount !== 0
        ? Math.min(Math.max(adjustedDiscount, 250), LeastDiscount)
        : Math.max(adjustedDiscount, 250);


  const CartCount = cart.reduce((total, item) => total + (item.quantity || 0), 0);
  const newGuid = uuidv4();
  const [SaveLoading, setSaveLoading] = useState(false);
  const [BranchInformationStatus, setBranchInformationStatus] = useState('Branch');
  const [ThemeColor, setThemeColor] = useState('');

  const [PromoCodeStatus, setPromoCodeStatus] = useState(0);
  const [PromoCodeStatusChick, setPromoCodeStatusChick] = useState(0);
  const [ListOfPromoCode, setListOfPromoCode] = useState([]);
  const [PromoAddress, setPromoAddress] = useState('');
  const [ShowAddress, setShowAddress] = useState(0);
  const [PromoCode, setPromoCode] = useState('');
  const [DBTransListPrice, setDBTransListPrice] = useState([]);
  const [ShowAddressBar, setShowAddressBar] = useState(false);

  const [ServiceStatus, setServiceStatus] = useState(false);
  const [ServiceComparePrice, setServiceComparePrice] = useState(0);
  const [ServiceBigger, setServiceBigger] = useState(0);
  const [ServiceEqualSmaller, setServiceEqualSmaller] = useState(0);
 

  const ServicPrice =ServiceStatus==true? (CartTotalPrcice-CartTotalDiscount > ServiceComparePrice?ServiceBigger:ServiceEqualSmaller):0
    
   

  function lightenColor(hex, percent) {
    const num = parseInt(hex, 16);
    const r = Math.min(255, (num >> 16) + 255 * percent);
    const g = Math.min(255, ((num >> 8) & 0x00FF) + 255 * percent);
    const b = Math.min(255, (num & 0x0000FF) + 255 * percent);
    return (
      '#' +
      ((1 << 24) + (Math.round(r) << 16) + (Math.round(g) << 8) + Math.round(b))
        .toString(16)
        .slice(1)
    );
  }



  const handleTryAgain = () => {
    setPromoCode(''); // Clear the input
    setPromoCodeStatusChick(0); // Reset the status to allow editing
    // Optionally, trigger a re-fetch or clear any error messages
  };

  function getBranchPromoCode(value) {
    setPromoCode(value);
    let input = value;

    // Convert Arabic and Persian numbers to English
    const convertedValue = input.replace(
      /[\u0660-\u0669]/g, d => d.charCodeAt(0) - 0x0660
    ).replace(
      /[\u06F0-\u06F9]/g, d => d.charCodeAt(0) - 0x06F0
    );

    // Only proceed if convertedValue is exactly 6 digits
    if (/^\d{6}$/.test(convertedValue)) {
      const item = ListOfPromoCode.find(obj => obj.promocode === convertedValue);

      if (item) {
        setPromoCode(`تم تطبيق الكود. حصلت على خصم % ${item.promoDiscount}`);
        setPromoCodeStatusChick(1)
        setBranchDiscount(item.promoDiscount);
        setPromoAddress(item.promoAddress);

        if (item.promoType === 'address' || item.promoType === 'addresswithtrans') {
          setCostAddress(item.promoAddress);
          setShowAddress(1);

          if (item.promoType === 'addresswithtrans') {
            setDeliveryTransPrice(item.promoTransPrice);
          }
        } else {
          setCostAddress('');
          setShowAddress(0);
        }
      } else {
        // Promo code not found
        setPromoCode(`الكود غير صحيح`);
        setPromoCodeStatusChick(2)
        setBranchDiscount(DBBranchDiscount);
        setDeliveryTransPrice(DBDeliveryTransPrice);
        setPromoAddress('');
        setCostAddress('');
        setShowAddress(0);
      }
    }
  }




  const [sentObject, setSendObject] = useState({

    listGuid: '',

    costName: '',
    costAddress: '',
    costPhone: '',
    listTotalPrice: 0,
    totalDiscount: 0,
    afterDiscount: 0,
    branchDiscount: 0,
    note: '',
    branchId: '',
    listDate: '',
    orderType: "App",
    deliveryTransPrice: 0,
    servicPrice: 0,
    listOfShoppingProduct: []
  })
  const formatISODateTime = (date) => {
    const tzOffset = -date.getTimezoneOffset() * 60000; // offset in milliseconds
    const localISOTime = new Date(date.getTime() + tzOffset).toISOString().slice(0, 19); // without milliseconds
    return localISOTime;
  };




  function SaveCart(Token) {

    const options = {
      headers: {
        'Authorization': `Bearer ${Token}`
      }
    }
    sentObject.listGuid = newGuid;
    sentObject.costName = '';
    sentObject.costAddress = `${CostAddress} ${Note}`.trim();
    sentObject.costPhone = CostPhone.slice(-10);
    sentObject.listTotalPrice = CartTotalPrcice;
    sentObject.totalDiscount = CartTotalDiscount;
    sentObject.afterDiscount = CartTotalPrcice - CartTotalDiscount;
    sentObject.branchDiscount = BranchDiscount;
    sentObject.note = '';
    sentObject.branchId = BranchIDFromUrl;
    sentObject.listOfShoppingProduct = cart;
    sentObject.listDate = formatISODateTime(CurrentDateTime);
    sentObject.orderType = "App"
    sentObject.deliveryTransPrice = DeliveryTransPrice
    sentObject.servicPrice = ServicPrice
    //   console.log(JSON.stringify(sentObject))

    setSaveLoading(true);
    axios.post(`${process.env.REACT_APP_API_URL}api/List/AddShoppingCart`, sentObject, options).then((res) => {
      if (res.data.isSuccess) {

        setSaveLoading(false);
        setCart([])
        setSelectedType('Done')
        setOtp(new Array(3).fill(""))
        setCostPhone('')
        setCostAddress('')
        setNote('')

        setShowSuccessAlert(true);
        setTimeout(() => {
          setShowSuccessAlert(false);
        }, 4000);

      } else {

        alert(res.data.message)
        setSaveLoading(false);
      }
    })




  }

  const addToCart = (product) => {

    let noteToMatch = ''

    if (SelectedItemSize == null) {
      noteToMatch = ItemNote

    } else {
      noteToMatch = `${SelectedItemSize.sname} ${ItemNote}`;
    }

    let noteToPrice = 0
    if (SelectedItemSize == null) {
      noteToPrice = product.itemPrice

    } else {
      noteToPrice = product.itemPrice + SelectedItemSize.sPrice;
    }

    const existingProduct = cart.find(item => item.itemID === product.itemID && item.itemNote == noteToMatch);
    if (existingProduct) {
      const seq = existingProduct.itemSeq
      // Increase the quantity of existing product by 1
      const updatedCart = cart.map(item => {
        if (item.itemID === product.itemID && item.itemNote == noteToMatch) {
          return { ...item, quantity: item.quantity + ItemCount, totalPrice: item.totalPrice + (noteToPrice * ItemCount) };
        }
        return item;
      });
      setCart(updatedCart);
      setItemCount(1)
      //   console.log(cart)

    } else {
      // Add the product as a new item in the cart
      //i use timeStatus:product.withTimePrice  cause make it default run as timeStatus=1 the item with type withTime
      const newItem = { itemID: product.itemID, itemNote: noteToMatch, itemName: product.itemName, qPrice: noteToPrice, quantity: ItemCount, totalPrice: ItemCount * noteToPrice, imageUrl: product.imageUrl, realPrice: product.itemPrice, memPrice: 0, sizePrice: noteToPrice - product.itemPrice, sizeName: SelectedItemSize == null ? '' : SelectedItemSize.sname, memName: ItemNote, sizeNameEnglish: SelectedItemSize == null ? '' : SelectedItemSize.snameEnglish };

      setCart([...cart, newItem]);

      setItemCount(1)

    }
    setItemNote('')
    //   console.log(cart)
    ShowDetails('Back')




  };


  const Dcrement = (product) => {


    const updatedCart = cart.map(item => {
      if (item.itemID === product.itemID && item.itemNote == product.itemNote) {
        if (item.quantity - 1 === 0) {

          // Item quantity will become zero, so remove it from the cart
          return null;

        } else {
          return { ...item, quantity: item.quantity - 1, totalPrice: item.totalPrice - product.qPrice };
        }
      }
      return item;
    });

    // Remove any null values from the updated cart
    const filteredCart = updatedCart.filter(item => item !== null);

    setCart(filteredCart);



  };



  const Increment = (product) => {


    const updatedCart = cart.map(item => {
      if (item.itemID === product.itemID && item.itemNote == product.itemNote) {

        return { ...item, quantity: item.quantity + 1, totalPrice: item.totalPrice + product.qPrice };

      }
      return item;
    });

    // Remove any null values from the updated cart
    const filteredCart = updatedCart.filter(item => item !== null);

    setCart(filteredCart);



  };

//  const s3 = new AWS.S3({
   // accessKeyId: 'AKIATAMS4FZYBVRBXP6V1',
  //  secretAccessKey: 'T0Z3TNSGW3m0fEbhH70uSomW5n6x/nNMyE3TLJ021',
  //  region: 'us-east-2'
 // });

 // const getPresignedUrl = (imageName) => {
  //  const params = {
  //    Bucket: 'allamea-s3-emenu-storage',
  //    Key: `EmenuImages/${imageName}`, // Corrected here
     
  //  };
  //  return s3.getSignedUrl('getObject', params);
 // };


  function GetBranchInformation(BranchID) {


    axios.get(`${process.env.REACT_APP_API_URL}api/Agency/GetBranchINformation?BranchId=${BranchID}`)
      .then((res) => {


        setRestInformation(res.data);
        setSubsecriptionType(res.data.subsecriptionType)
        setBranchDiscount(res.data.branchDiscount)
        setDBBranchDiscount(res.data.branchDiscount)
        setDeliveryTransPrice(res.data.deliveryTransPrice)
        setDBDeliveryTransPrice(res.data.deliveryTransPrice)
        setOrederMinimunAmount(res.data.orederMinimunAmount)
        setThemeColor(res.data.themeColor)
        setPromoCodeStatus(res.data.promoCodeStatus)
        setListOfPromoCode(res.data.listOfPromoCode)
        setLeastDiscount(res.data.leastDiscount)
        setServiceStatus(res.data.serviceStatus)
        setServiceComparePrice(res.data.serviceComparePrice)
        setServiceBigger(res.data.serviceBigger)
        setServiceEqualSmaller(res.data.serviceEqualSmaller)

        if (res.data.listOfShoppingProduct === null) {

        //  const url = getPresignedUrl(res.data.branchLogo);
          setBranchimageUrl(res.data.imageUrl);

          setBranchInformationStatus('branch')
          GetDBDpartment(BranchID)

          GetDBGroups(BranchID)
          GetDBItems(BranchID)
          GetDBItemsSizes(BranchID)
          GetDBTransListPrice(BranchID)


        } else {
         // const url = getPresignedUrl(res.data.branchDoc);
         // setBranchimageUrl(url);
        //  setBranchInformationStatus('agency')
        //  const images = res.data.listOfShoppingProduct.map(product => ({
       //     ...product,
       //     imageUrl: getPresignedUrl(product.groupNamDoc)
       //   }));


        //  setDBGroups(images);
         // setGroups(images);


        }

      });







  }


  function GetDBDpartment(BranchID) {
    axios.get(`${process.env.REACT_APP_API_URL}api/Department/GetAllDepatments?BranchId=${BranchID}`)
      .then((res) => {
        setDBDepartment(res.data);
        if (res.data && res.data.length > 0) {


          setSelectedCardIndex(0);
          setSelectedDepartment(res.data[0].did)
        }


      });
  }

  function GetDBGroups(BranchID) {
    axios.get(`${process.env.REACT_APP_API_URL}api/Groups/GetAllGroupsForBranchSecure?BranchId=${BranchID}`)
      .then((res) => {




        setDBGroups( res.data);
        setGroups( res.data);
console.log(res.data)




      });
  }


  function GetDBItems(BranchID) {
    axios.get(`${process.env.REACT_APP_API_URL}api/Items/GetAllItemsForBranchSecure?BranchId=${BranchID}`)
      .then((res) => {
        setDBItems(res.data)
      // console.log(res.data)

      })
      .catch((error) => {
        // Handle any errors from the API call
        console.error('Error fetching items:', error);
      });
  }

  function GetDBItemsSizes(BranchID) {
    axios.get(`${process.env.REACT_APP_API_URL}api/Items/GetItemSizsForBranch?BranchId=${BranchID}`)
      .then((res) => {
        setDBItemSize(res.data)


      });
  }
  function GetDBTransListPrice(BranchID) {


    axios.get(`${process.env.REACT_APP_API_URL}api/TransCompany/GetTransAddressPriceListForSepecificBranch?BranchId=${BranchID}`)
      .then((res) => {

        const filteredData = res.data.filter(item => item.transStaus === 1);
        setDBTransListPrice(res.data);



      });
  }


  const [BranchIDFromUrl, setBranchIDFromUrl] = useState(null);
  const [CurrentDateTime, setCurrentDateTime] = useState(null);


  useEffect(() => {

    const interval = setInterval(() => {

      const now = new Date();
      setCurrentDateTime(now);

    }, 1000);


    axios.get(`${process.env.REACT_APP_API_URL}api/Agency/GetBrancheIdFromUrl?BranchUrl=${param.branchID}`)
      .then((res) => {
        setBranchIDFromUrl(res.data)

        // console.log(res.data)
        if (res.data) {
          // Call your functions if data exists
          GetBranchInformation(res.data)
          // console.log(res.data)
        }
      });






  }, []); // Add branchIDa to the dependency array

  useEffect(() => {
    if (isTimerRunning && timeLeft > 0) {
      const timerId = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);

      return () => clearTimeout(timerId); // Cleanup the timer
    } else if (timeLeft === 0) {
      ShowDetails('Continue');
      setTimeLeft(60)
    }
  }, [isTimerRunning, timeLeft]);


  const handleCardClick = (index, DeptName) => {
    setSelectedCardIndex(index);
    ShowDetails('Group', DeptName);
  };

  const ShowSearch = (Type) => {
    setItems([])
    setSearchedItem('')
    setSelectedType(Type);

  };

  const LangChange = (LangID) => {
    setLanguageID(LangID);
  };


  const ShowDetails = (type, value, row) => {

    if (type === 'Group') {

      setShowAddressBar(false)
      setSelectedDepartment(value);
      setSelectedType('Group');
      setBackStatus('Item')

      const FilterGroup = DBGroups.filter(item => item.did === value);
      setGroups([])
      setGroups(FilterGroup)

    }
    if (type === 'Item') {


      if (BranchInformationStatus === 'branch') {
        setSelectedType('Item');
        setSelectedGroup(value);

        if (LanguageID == 1) {
          setSelectedGroupName(row.groupName)
        }
        if (LanguageID == 2) {
          setSelectedGroupName(row.groupNameEnglish)
        }
        if (LanguageID == 3) {
          setSelectedGroupName(row.groupNameKurdish)
        }

        setBackStatus('Item')
        const FilterGroup = DBItems.filter(item => item.gid === value);
        setItems(FilterGroup);
      } else {

        window.location.href = `/EMenu/${row.branchUrl}`;
      }



    }

    if (type === 'Details') {
      setProduct(row)
      setSelectedType('Details');
      setSelectdetItem(value);
      const FilterGroup = Items.filter(item => item.itemID === value);

      setItemDetails(FilterGroup)

      const FilterSizes = DBItemSize.filter(item => item.itemID === value);
      setItemSize(FilterSizes);


    }

    if (type === 'Done') {

      setSelectedType('Group');


    }

    if (type === 'Back') {

      if (BackStatus == 'Item') {
        setSelectedType('Item');


      }



      if (BackStatus == 'SearchItem') {
        setSelectedType('SearchPanel');

      }

    }

    if (type == 'SearchItem') {

      if (value == '' || value == null) {
        setSearchedItem('')
        setItems([]);

      }
      else {
        setSearchedItem(value)
        setBackStatus('SearchItem')

        if (LanguageID == 1) {
          const FilterGroup = DBItems.filter(item => item.itemName.includes(value));



          setItems(FilterGroup);
        }
        if (LanguageID == 2) {
          const FilterGroup = DBItems.filter(item => item.itemNameEnglish.includes(value));
          setItems(FilterGroup);
        }

        if (LanguageID == 3) {
          const FilterGroup = DBItems.filter(item => item.itemNameKurdish.includes(value));
          setItems(FilterGroup);
        }
      }







    }


    if (type == 'Cart') {

      setSelectedType('Cart');
    }
    if (type == 'Continue') {


      if (SubsecriptionType == 'ECart' & CartTotalPrcice < OrederMinimunAmount) {
        alert(`يجب ان تكون قيمة الفاتورة لاتقل عن ${OrederMinimunAmount} دينار`)
        return
      }
      if (SubsecriptionType == 'ECart' & CostAddress == '') {

        alert('الرجاء اختيار عنوان')
        return

      }
      setSelectedType('Continue');
      setAddCartButtonStatus('PhoneInfo')







    }


  }

  const checkForNumbers = (text) => {

    if (text.length >= 10) {
      const regex = /(77|78|75|76|74)/;
      return regex.test(text.slice(-10, -8));
    }
    return false;
  };
  const handleInputChange = (e) => {
    let input = e.target.value;

    // Convert Arabic numbers (٠١٢٣٤٥٦٧٨٩) to English (0123456789)
    const convertedValue = input.replace(
      /[\u0660-\u0669]/g,  // Arabic-Indic digits
      (d) => d.charCodeAt(0) - 0x0660
    ).replace(
      /[\u06F0-\u06F9]/g,  // Persian digits
      (d) => d.charCodeAt(0) - 0x06F0
    );

    // Allow only numbers (prevent letters or symbols)
    if (/^\d*$/.test(convertedValue)) {
      setCostPhone(convertedValue);
    }
  };


  const SendVerfication = () => {
    if (SubsecriptionType == 'ECart' & CartTotalPrcice < OrederMinimunAmount) {
      alert(`يجب ان تكون قيمة الفاتورة لاتقل عن ${OrederMinimunAmount} دينار`)
    }
    else {


      if (CostAddress == '') {
        alert('الرجاء املاء العنوان')
      } else {
        if (SubsecriptionType == 'ECart') {

          if (CostPhone.length < 10 || !checkForNumbers(CostPhone)) {
            alert('الرجاء التاكد من رقم الهاتف')
          }
          else {
            setSaveLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}api/Twilio/SendVerficationCode?PhoneNo=${CostPhone.slice(-10)}`)
              .then((res) => {
                if (res.data.isSuccess) {

                  setSaveLoading(false);
                  setAddCartButtonStatus('WaitingCode')
                  setTimeLeft(60)
                  setIsTimerRunning(true);
                  setOtp(new Array(3).fill(""))
                } else {
                  alert(res.data.message)
                  setSaveLoading(false);


                }
              });
          }

        } else {
          const url = createWhatsAppLink();
          window.location.href = url;

          setCart([])
          setSelectedType('Group')
          setOtp(new Array(3).fill(""))
          setCostPhone('')
          setCostAddress('')
          setNote('')
          setShowSuccessAlert(true);
          setTimeout(() => {
            setShowSuccessAlert(false);
          }, 2000);
        }
      }









    }










  }

  const CheckVerfication = () => {

    axios.get(`${process.env.REACT_APP_API_URL}api/Twilio/CheckPhoneVerfication?PhoneNo=${CostPhone.slice(-10)}&VerificationCode=${Otp.join("")}`)
      .then((res) => {
        if (res.data.isSuccess) {

          SaveCart(res.data.token)


        } else {
          alert(res.data.message)



        }
      });


  }


  const createWhatsAppLink = () => {

    const phone = RestInformation.branchPhone; // Remove any non-digit characters

    const Space = "--------------------------------"
    const message = cart.map(item => ` ${item.itemName} ${item.quantity}x${item.qPrice}  `).join('\n');
    const fullMessage = `العنوان: ${CostAddress}\n${Space}\nالتفاصيل\n${message}\n${Space}\nالمجموع : ${CartTotalPrcice} د.ع\nالخصم : ${CartTotalDiscount} د.ع\nبعد الخصم : ${CartTotalPrcice - CartTotalDiscount} د.ع`;

    const fullMessageWithNote = `${fullMessage}\n${Space}\n الملاحظات \n${Note}`;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(fullMessageWithNote)}`;




    return url;
  };



  return (
    <div style={{ direction: 'rtl' }}>
      <div style={{
        position: 'relative',
        height: '70vh',
        display: 'flex',
        // Set a fixed height for the container

        backgroundColor: BranchInformationStatus == 'branch' ? `#${ThemeColor}` : '#B98844',
      }}>
        {/* صورة الخصم */}
        {(SelectedType !== 'Details' && SelectedType !== 'SearchPanel' && SelectedType !== 'Item' && SelectedType !== 'Cart' && SelectedType !== 'Continue') && (

          <div>
            {RestInformation.branchDiscount > 0 && (
              <div style={{ position: 'absolute', top: '16vh', left: '75px', zIndex: 100 }}>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img style={{ width: '239.05px', height: '38px' }} src={OfferIcon} alt="Offer" />

                  {RestInformation.leastDiscount == 0 ? (
                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      display: 'flex',
                      gap: '12px', // Increased space between the two spans
                      alignItems: 'center',
                    }}>
                      <span style={{
                        color: '#D62828',
                        fontSize: '22px',
                        fontFamily: 'basheer',
                      }}>
                        خصم
                      </span>
                      <span style={{
                        color: '#D62828',
                        fontSize: '27px',
                        fontFamily: 'basheer',
                      }}>
                        {RestInformation.branchDiscount}%
                      </span>
                    </div>
                  ) : (

                    <div style={{
                      position: 'absolute',
                      top: '50%',
                      left: '35%',

                      transform: 'translate(-25%, -50%)',
                      display: 'flex',


                    }}>

                      <span style={{
                        color: '#D62828',
                        fontSize: '13px',
                        fontFamily: 'basheer',
                      }}>
                        خصم   {RestInformation.branchDiscount}%  لغاية {RestInformation.leastDiscount} د.ع
                      </span>
                    </div>

                  )}
                </div>

              </div>
            )}

            <div style={{
              position: 'absolute',
              top: '2vh',
              right: '3vw', // optional positioning
              width: '56px', // outermost circle
              height: '56px',
              borderRadius: '50%',
              backgroundColor: 'white', // red outer circle
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <div style={{
                width: '54px', // middle circle
                height: '54px',
                borderRadius: '50%',
                backgroundColor: `#${ThemeColor}`, // white middle circle
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <div style={{
                  width: '50px', // innermost circle
                  height: '50px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                }}>
                  <img
                    src={BranchimageUrl}
                    alt="Logo"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '50%',
                    }}
                  />
                </div>
              </div>
            </div>



            <div style={{ right: '20vw', top: '3vh', position: 'absolute', }}>
              <div >
                <label style={{ color: 'white', fontSize: '22pt', fontFamily: 'basheer' }}>{RestInformation.branchName}</label>
              </div>


              <div>

                <div className='row' style={{ display: 'flex' }}>

                  <div className='col' style={{ width: '100%', textAlign: 'start' }}>
                    <label style={{ fontSize: '10pt', display: 'block', color: 'white' }}> <img style={{ marginLeft: '5px', width: '10px', height: '10px' }} src={LocationIcon} alt="Icon" />  {RestInformation.branchAddress} </label>

                    <label style={{ fontSize: '10pt', color: 'white' }}> <img style={{ marginLeft: '10px', width: '10px', height: '10px' }} src={PhoneIcon} alt="Icon" />{RestInformation.branchPhone}  </label>
                  </div>

                </div>

              </div>



            </div>

          </div>




        )}

        {(SelectedType == 'Item' || SelectedType == 'Cart' || SelectedType == 'Continue') && (

          <div>


            {(ShowAddressBar == 0) && (
              <button onClick={() => ShowDetails('Group', SelectedDepartment)} style={{
                width: '40px', height: '40px', borderRadius: '4px', backgroundColor:
                  `#${ThemeColor}`, position: 'absolute', display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                top: '2vh',
                right: '8vw',
              }} type="button">  <img src={ForwardIcon} alt="Icon" /> </button>
            )}

            <div style={{ right: '25vw', top: '2.5vh', position: 'absolute', }}>

              {(ShowAddressBar == 0) && (
                <div >
                  {(SelectedType == 'Item') && (
                    <label style={{ color: 'white', fontSize: '20pt', fontFamily: 'basheer', }}>{SelectedGroupName}</label>
                  )}
                  {(SelectedType == 'Cart' || SelectedType == 'Continue') && (
                    <label style={{ color: 'white', fontSize: '20pt', fontFamily: 'basheer', }}>تفاصيل الطلب</label>
                  )}

                </div>
              )}



              <div>



              </div>



            </div>

          </div>
        )}


        {/* خلفية الشعار واسم الفرع*/}
        <div style={{
          position: 'absolute',
          top: SelectedType == 'Item' || SelectedType == 'Cart' || SelectedType == 'Continue' ? '9vh' : (SelectedType !== 'Details' && SelectedType !== 'SearchPanel' && SelectedType !== 'Continue'
            ? '16vh'
            : '0'),
          height: '100%', // Adjust the height as needed
          width: '100%',
          borderRadius: '24px 24px 0% 0%',
          backgroundColor: 'white',
        }}>
          {/*  البحث والاقسام  */}
          {(SelectedType !== 'Details' && SelectedType !== 'SearchPanel' && SelectedType !== 'Cart' && SelectedType !== 'Continue' && SelectedType !== 'Done') && (
            <div style={{ direction: 'ltr' }}>

              <ResturantInfoPanel
                ShowSearch={ShowSearch}
                RestInformation={RestInformation}
                handleCardClick={handleCardClick}
                selectedCardIndex={selectedCardIndex}
                DBDepartment={DBDepartment}
                LanguageID={LanguageID}
                SelectedType={SelectedType}
                SelectedDepartment={SelectedDepartment}
                SelectedGroupName={SelectedGroupName}
                ShowDetails={ShowDetails}
                BranchInformationStatus={BranchInformationStatus}

              />
            </div>
          )}
          {/*   المجموعات او المواد او السلة او تفاصيل المادة  */}
          <div style={{ direction: 'ltr' }}>
            <MainMenuCards
              Groups={Groups}
              LanguageID={LanguageID}
              SelectedType={SelectedType}
              ShowDetails={ShowDetails}
              Items={Items}
              ItemDetails={ItemDetails}
              cart={cart}
              SubsecriptionType={SubsecriptionType}
              RestInformation={RestInformation}
              ItemCount={ItemCount}
              setItemCount={setItemCount}
              Dcrement={Dcrement}
              Increment={Increment}
              CartTotalPrcice={CartTotalPrcice}
              CartTotalDiscount={CartTotalDiscount}
              DeliveryTransPrice={DeliveryTransPrice}
              setDeliveryTransPrice={setDeliveryTransPrice}
              ItemSize={ItemSize}
              SelectedItemSize={SelectedItemSize}
              setSelectedItemSize={setSelectedItemSize}
              ThemeColor={ThemeColor}
              ItemNote={ItemNote} setItemNote={setItemNote}
              CartCount={CartCount}
              PromoCodeStatus={PromoCodeStatus}
              ListOfPromoCode={ListOfPromoCode}
              getBranchPromoCode={getBranchPromoCode}
              PromoCode={PromoCode}
              PromoCodeStatusChick={PromoCodeStatusChick}
              handleTryAgain={handleTryAgain}
              DBTransListPrice={DBTransListPrice}
              setCostAddress={setCostAddress}
              CostAddress={CostAddress}
              ShowAddressBar={ShowAddressBar}
              setShowAddressBar={setShowAddressBar}
              ShowAddress={ShowAddress}
              ServiceStatus={ServiceStatus}
              ServicPrice={ServicPrice}

            />
          </div>
          {/*   تفاصيل البحث  */}
          <div style={{ direction: 'ltr', margin: '20px' }}>
            <SearchPanel

              LanguageID={LanguageID}
              SelectedType={SelectedType}
              ShowDetails={ShowDetails}
              Items={Items}
              ItemDetails={ItemDetails}
              SelectedDepartment={SelectedDepartment}
              SearchedItem={SearchedItem}
              SubsecriptionType={SubsecriptionType}
              RestInformation={RestInformation}
              ThemeColor={ThemeColor}
            />
          </div>

          {/*   زر العرض والاضافة  */}
          {((CartCount > 0 || (SelectedType == 'Details') || (SelectedType == 'Done')) &&

            <AddCartButton ShowDetails={ShowDetails} product={Product} addToCart={addToCart}

              CartCount={CartCount}
              CartTotalPrcice={CartTotalPrcice}
              CartTotalDiscount={CartTotalDiscount}
              SelectedType={SelectedType}
              ItemCount={ItemCount}
              setItemCount={setItemCount}
              CostAddress={CostAddress}
              setCostAddress={setCostAddress}
              costPhone={CostPhone}
              setCostPhone={setCostPhone}
              Note={Note}
              setNote={setNote}
              AddCartButtonStatus={AddCartButtonStatus}
              SendVerfication={SendVerfication}
              CheckVerfication={CheckVerfication}
              timeLeft={timeLeft}
              SubsecriptionType={SubsecriptionType}
              Otp={Otp}
              setOtp={setOtp}
              SaveLoading={SaveLoading}

              setItemNote={setItemNote}
              DeliveryTransPrice={DeliveryTransPrice} handleInputChange={handleInputChange} ThemeColor={ThemeColor}
              ShowAddress={ShowAddress}
              PromoAddress={PromoAddress}
              ShowAddressBar={ShowAddressBar}  ServicPrice={ServicPrice}
            />

          )}
        </div>



      </div>

    </div>

  );
};

export default EMenu;




